import React, { useState, useEffect } from 'react'
import { Button, Tag } from 'antd'
import { Moment } from '../../helpers'
import { UserOutlined } from '@ant-design/icons'

export const JobTechnichian = ({ technicians, technicianOther }) => {
  // ชื่อช่าง
  const technicianName = (technicians) => {
    if (technicians && technicians.length > 0) {
      let names = []
      technicians.map((v, tkey) => {
        if (v.technician) {
          if (v.technician) {
            names.push(
              <span color="" key={v.technician.id} style={{ marginRight: 3 }}>
                {tkey >= 1 ? ', ' : ''} {v.technician.firstname}{' '}
                {v.technician.lastname}
              </span>,
            )
          }
        }
      })
      return names
    }
  }

  const showTechnicaianName = (items) => {
    if (items && items.length > 0) {
      const allName = items.map((item, tkey) => {
        const nickname = item.technician.nickname
          ? '(' + item.technician.nickname + ')'
          : ''
        const fullname = `${item.technician.firstname} ${item.technician.lastname}`
        return (
          <span key={tkey} className="item__name" style={{
            marginRight: 7
          }}>
            {fullname}
          </span>
        )
      })

      return <span><UserOutlined /> {allName}</span>
    } else {
      // return (
      //   <span>
      //     {<UserOutlined />} ไม่ได้ระบุช่าง
      //   </span>
      // )
    }
  }
  const showTechnicaianNameOther = (name) => {
    if (name) {
      return (
        <>
          <span style={{
            marginRight: 7
          }}>({name})</span>
        </>
      )
    }
  }

  return (
    <React.Fragment>
      {showTechnicaianName(technicians)}{' '}
      {showTechnicaianNameOther(technicianOther)}
    </React.Fragment>
  )
}
